module.exports = __webpack_public_path__ + "img/bar.bfe215c8.png";